import React, { useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import ThumbUpOutlinedIcon from '@mui/icons-material/ThumbUpOutlined';
import { ChangePasswordForm } from 'Components/Login/Login';
import useForm from 'hooks/useForm';
import Modal from '../Modal';
import { updatePassword } from './services';

const ChangePasswordBody = ({ onClose }) => {
  const { onChange, values } = useForm({
    currentPassword: '',
    newPassword: '',
    newPassword2: '',
    showPassword: false,
    showPassword2: false,
    showPassword3: false,
  });
  const [open, setOpen] = useState(false);

  const onCloseAll = () => {
    onClose();
    setOpen(false);
  };

  const isValide = values.currentPassword
    && values.newPassword !== ''
    && values.newPassword === values.newPassword2;

  const onUpdatePwd = async () => {
    const data = await updatePassword({
      oldPassword: values?.currentPassword,
      newPassword: values.newPassword,
    });
    if (data) setOpen(true);
  };

  return (
    <Box sx={{ p: { xs: '10px 44px 100px', sm: '10px 250px 100px' } }}>
      <Typography sx={{
        color: '#4D4D4D', fontSize: '16px', fontWeight: 600, textAlign: 'center',
      }}
      >
        Changement de mot de passe
      </Typography>
      <ChangePasswordForm values={values} onChange={onChange} />
      <Box sx={{ mt: 4, display: 'flex', justifyContent: { xs: 'center', sm: 'end' } }}>
        <Button
          onClick={onClose}
          variant="contained"
          color="inherit"
          sx={{
            border: '2px solid #CCCCCC', color: '#CCCCCC', backgroundColor: '#FFFFFF', textTransform: 'capitalize',
          }}
        >
          Annuler
        </Button>
        <Button
          disabled={!isValide}
          onClick={onUpdatePwd}
          variant="contained"
          color="primary"
          sx={{ ml: '10px', textTransform: 'capitalize' }}
        >
          Enregistrer
        </Button>
      </Box>
      <Modal open={open} setOpen={setOpen}>
        <Box sx={{ p: '20px 40px', textAlign: 'center' }}>
          <ThumbUpOutlinedIcon fontSize="large" color="primary" />
          <Typography sx={{
            color: '#8F8F8F', fontSize: 14, fontWeight: 600, mt: 2.5, mb: 2.5,
          }}
          >
            Modification enregistrée avec succès
          </Typography>
          <Button onClick={onCloseAll} variant="contained" color="primary" sx={{ textTransform: 'capitalize' }}>
            Fermer
          </Button>
        </Box>
      </Modal>
    </Box>
  );
};

export default ChangePasswordBody;
